import {
  DashboardOutlined,
  DollarOutlined,
  ExperimentOutlined,
  NotificationOutlined,
  TeamOutlined,
} from "@ant-design/icons";

export const sideBarOptions = [
  {
    icon: <DashboardOutlined />,
    label: "Sites",
    key: "/sites",
  },
  {
    icon: <NotificationOutlined />,
    label: "Alerting Settings",
    key: "/alerting",
  },
  {
    icon: <TeamOutlined />,
    label: "Team",
    key: "/identities",
    partnerOnly: true,
  },
  {
    icon: <DollarOutlined />,
    label: "Invoicing",
    key: "/billing",
    adminOnly: true,
  },
  {
    icon: <ExperimentOutlined />,
    label: "Emulator",
    key: "/emulator",
    adminOnly: true,
  },
];
